import React, { forwardRef } from "react";

import { ScrollableContainer as Styled } from "./ScrollableContainer.styled";

const ScrollableContainer = forwardRef(({ children, maxHeight }, ref) => {
    return (
        <Styled $maxHeight={maxHeight} ref={ref}>
            {children}
        </Styled>
    );
});

ScrollableContainer.displayName = "ScrollableContainer";

export default ScrollableContainer;
